import { o_global } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
const debugSync = o_global.debug ?? {};
const logger = debugSync.logger;
const scope = debugSync.scope;
const Level = debugSync.Level;
const status = debugSync.status;
const sendLog = (otto.apm ?? {}).sendCustomError;
export {
  Level,
  debugSync,
  logger,
  scope,
  sendLog,
  status
};
